import { Component, OnDestroy, OnInit } from '@angular/core';
import { ColorInterfaceHeader, Titles } from '@3ddv/ngx-sites-builder-lib';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sbeditor-tool-titles',
  templateUrl: './titles.component.html',
  styleUrls: ['./titles.component.scss']
})
export class TitlesComponent implements OnInit, OnDestroy {

  private subscriptions: Array<Subscription>;
  public tool: Titles =null;
  public colors: ColorInterfaceHeader=null;

  @Output() exportTool = new EventEmitter<Titles>();

  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
      const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
        if(res.titles){
          this.tool = Object.assign({},res.titles);
          this.colors = JSON.parse(JSON.stringify(res.color.manual.header));
        }else{
          console.error("Titles tool not found");
          return;
        }

      });
      this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe());
  }

  public getTool(){
    return {tool: this.tool, color: this.colors};
  }
}
